import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MainMenuComponent } from './main-menu/main-menu.component';
import { BasicInformationComponent } from './basic-information/basic-information.component';
import { OffersComponent } from './offers/offers.component';
import { ConfirmComponent } from './confirm/confirm.component';
import { DetailsComponent } from './details/details.component';
import {RouterModule, Routes} from '@angular/router';
import {RoleGuard} from '../../services/guards/role-guard.service';
import {CustomButtonModule} from '../../Elements/custom-button/custom-button.module';
import {MainNavBarModule} from '../../Elements/main-nav-bar/main-nav-bar.module';
import {FormListGeneratorModule} from '../../Elements/form-list-generator/form-list-generator.module';
import {FormModule} from '../../Elements/form/form.module';
import {DetailsDivModule} from '../../Elements/details-div/details-div.module';
import {FinanceInvoiceDivModule} from '../../Elements/finance-invoice-div/finance-invoice-div.module';
import {FileUploadDivModule} from '../../Elements/file-upload-div/file-upload-div.module';

const routes: Routes = [
  {
    path: 'HEALTH_GROUP',
    children: [
      {
        path: 'main-menu',
        component: MainMenuComponent
      },
      {
        path: 'basic-information',
        component: BasicInformationComponent
      },
      {
        path: 'offers',
        component: OffersComponent,
      },
      {
        path: 'confirm',
        component: ConfirmComponent
      },
      {
        path: 'details',
        component: DetailsComponent,
        canActivate: [RoleGuard],
        data: {role: 'user'}
      }
    ]
  }
];

@NgModule({
  declarations: [MainMenuComponent, BasicInformationComponent, OffersComponent, ConfirmComponent, DetailsComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    CustomButtonModule,
    MainNavBarModule,
    FormListGeneratorModule,
    FormModule,
    DetailsDivModule,
    FinanceInvoiceDivModule,
    FileUploadDivModule
  ]
})
export class HealthGroupApplicationModule { }
